import {createAction} from "redux-actions";
import {keyBy} from 'lodash';

import {agreementMap} from "../../../utils/api/api-endpoint-dictionary";
import callApi from "../../../utils/api/axios";

const ASSOCIATE_AGREEMENTS = "ASSOCIATE_AGREEMENTS";

/**
 * Optimizes a single agreement map. See optimizeAgreementMapOfMaps below.
 * @param {AgreementMap} agreementMap
 * @returns {AgreementMapEx}
 */
function optimizeAgreementMap(agreementMap) {
  Object.keys(agreementMap).forEach(arrayKey => {
    const lookupKey = arrayKey.replace(/Agreements$/, 'Lookup');
    if (lookupKey === arrayKey) {
      // got a key we didn't expect, ignore
      return;
    }
    agreementMap[lookupKey] = keyBy(agreementMap[arrayKey]);
  });
}

/**
 * Given an agreement map with array lists of agreements, make a corresponding field for
 * each array that is a lookup map for those agreements.
 *
 * @param {Object.<string, AgreementMap>} mapOfMaps Map of lists of agreements for each attribute
 * @returns {Object.<string, AgreementMapEx>} Map of lists of agreements for each attribute with lookups
 */
function optimizeAgreementMapOfMaps(mapOfMaps) {
  if (typeof mapOfMaps !== 'object' || mapOfMaps === null) {
    return {};
  }
  Object.keys(mapOfMaps).forEach(key => optimizeAgreementMap(mapOfMaps[key]));
  return mapOfMaps;
}

export default function associatedAgreements(
  state = {
    isLoading: false,
    isLoaded: false,
    hasFailed: false,
    associatedAgreements: {},
  },
  { payload, type }
) {
  switch (type) {
    case `${ASSOCIATE_AGREEMENTS}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case `${ASSOCIATE_AGREEMENTS}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        associatedAgreements: optimizeAgreementMapOfMaps(payload.data),
      };

    case `${ASSOCIATE_AGREEMENTS}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    default:
      return state;
  }
}

export const getaAssociatedAgreements = () => {
  return (dispatch) => {
    const action = createAction(ASSOCIATE_AGREEMENTS)(callApi(agreementMap));
    return dispatch(action);
  };
};
